module.exports = __webpack_public_path__ + "img/icn_qr.e51724b9.svg";